// SQToggleButton.tsx
import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import { theme } from "../theme.ts";

interface SQButtonProps extends ButtonProps {
    selected: boolean;
}

export function SQToggleButton(props: SQButtonProps) {
    const StyledButton = styled(Button, {
        shouldForwardProp(propName: PropertyKey) {
            return propName !== "selected";
        },
    })<SQButtonProps>(({ selected /*theme*/ }) => {
        const borderProps = selected
            ? {
                color: "#FFFFFF", // White text for selected state
                border: "4px solid", // Thick black border
                borderColor: "#000000", // Black border
                backgroundColor: "#000000", // Black background
            }
            : {
                color: "#000000", // Black text for non-selected state
                border: "2px solid", // Thin black border
                borderColor: "#000000", // Black border
                backgroundColor: "transparent", // Transparent background
            };

        return {
            ...borderProps,
            textTransform: "none", // Keep text as is
            borderRadius: 10, // Slightly rounded corners
            flexGrow: 0, // Equal button sizes
            fontSize: theme.typography.button.fontSize, // Adjust font size for clarity
            height: "90%",
            fontWeight: 500, // Slightly bold text
            transition: "all 0.3s ease-in-out", // Smooth hover and selection transition
            padding: "4px 8px", // Reduced padding to fit more text
            minWidth: "auto", // Allow buttons to shrink according to content
            "&:hover": {
                backgroundColor: selected
                    ? "#333333" // Slightly lighter black on hover for selected
                    : "#f5f5f5", // Light gray background on hover for non-selected
            },
        };
    });

    return (
        <StyledButton {...props} sx={{ boxShadow: props.selected ? 3 : 0 }}>
            {props.children}
        </StyledButton>
    );
}
